import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/store/auth'

const HomeView = () => import('@/views/HomeView.vue')
const LoginView = () => import('@/views/LoginView.vue')
const RegisterView = () => import('@/views/RegisterView.vue')
const SetupView = () => import('@/views/SetupView.vue')
const ProfileView = () => import('@/views/ProfileView.vue')
const UsersView = () => import('@/views/UsersView.vue')
const SettingsView = () => import('@/views/SettingsView.vue')
const StudyQuizDetailView = () => import('@/views/StudyQuizDetailView.vue')
const TakeQuizView = () => import('@/views/TakeQuizView.vue')
const QuestionsView = () => import('@/views/QuestionsView.vue')
const QuestionDetailView = () => import('@/views/QuestionDetailView.vue')
const SearchView = () => import('@/views/SearchView.vue')
const NotFoundView = () => import('@/views/NotFoundView.vue')

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/', name: 'home', component: HomeView, meta: { requiresAuth: true } },
    { path: '/login', name: 'login', component: LoginView },
    { path: '/register', name: 'register', component: RegisterView },
    { path: '/setup', name: 'setup', component: SetupView },
    { path: '/profile', name: 'profile', component: ProfileView, meta: { requiresAuth: true } },
    {
      path: '/users',
      name: 'users',
      component: UsersView,
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/settings',
      name: 'settings',
      component: SettingsView,
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/quizzes/:id',
      name: 'quiz-detail',
      component: StudyQuizDetailView,
      meta: { requiresAuth: true },
    },
    {
      path: '/quizzes/:id/take',
      name: 'take-quiz',
      component: TakeQuizView,
      meta: { requiresAuth: true },
    },
    {
      path: '/quizzes/:id/questions',
      name: 'quiz-questions',
      component: QuestionsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/quizzes/:id/questions/:questionId',
      name: 'question-detail',
      component: QuestionDetailView,
      meta: { requiresAuth: true },
    },
    {
      path: '/quizzes/:id/search',
      name: 'search',
      component: SearchView,
      meta: { requiresAuth: true },
    },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFoundView },
  ],
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  await auth.checkAuthConfig()

  if (auth.setupRequired && to.name !== 'setup') {
    return { name: 'setup' }
  }
  if (to.name === 'setup' && !auth.setupRequired) {
    return { name: 'home' }
  }
  if (auth.isAuthenticated && (to.name === 'login' || to.name === 'register')) {
    return { name: 'home' }
  }
  if (to.name === 'register' && (!auth.authEnabled || !auth.userRegistrationEnabled)) {
    return { name: 'home' }
  }
  if (to.meta.requiresAuth && auth.authEnabled && !auth.isAuthenticated) {
    return { name: 'login' }
  }
  if (to.meta.requiresAdmin && auth.isAuthenticated && !auth.isAdmin) {
    return { name: 'home' }
  }
  return true
})

export default router
